document.addEventListener('DOMContentLoaded', function () {
  if (typeof Splide === 'undefined') return;

  const splide = new Splide('#pdp-design-image-splide', {
    type: 'loop', // Changed to loop for continuous auto-scroll
    perPage: 3,
    gap: '34px',
    focus: 'center',
    padding: 0,
    pagination: true,
    arrows: true,
    trimSpace: true,
    updateOnMove: true,
    
    // Auto-scroll configuration
    autoplay: true,
    interval: 2500, // 2.5 seconds between slides - faster auto-scroll
    pauseOnHover: true, // Pause when user hovers
    pauseOnFocus: true, // Pause when focused (accessibility)
    resetProgress: false, // Don't reset progress on manual navigation
    
    // Fast and smooth transitions
    speed: 500, // Faster transition speed in milliseconds
    easing: 'cubic-bezier(0.4, 0, 0.2, 1)', // Optimized smooth easing for speed
    
    // Enhanced interaction
    drag: true, // Allow dragging
    wheel: false, // Disable mouse wheel navigation
    releaseWheel: true, // Release wheel after interaction
    
    breakpoints: {
      1024: {
        perPage: 2,
        gap: '34px',
        padding: 0,
        trimSpace: true,
        interval: 3000, // Faster on tablet
      },
      768: {
        perPage: 1,
        gap: '20px',
        padding: 0,
        trimSpace: true,
        interval: 3500, // Faster on mobile
      },
    },
  });

  // Mount the slider
  splide.mount();

  // Enhanced auto-scroll controls
  initAutoScrollControls(splide);
  
  // Performance optimization
  initIntersectionObserver(splide);
  
  console.log('PDP Design Image Slider: Auto-scroll initialized');
});

/**
 * Initialize auto-scroll controls and user interaction handling
 */
function initAutoScrollControls(splide) {
  const sliderElement = document.querySelector('#pdp-design-image-splide');
  if (!sliderElement) return;

  let isUserInteracting = false;
  let interactionTimeout;

  // Pause auto-scroll on user interaction
  function pauseAutoScroll() {
    if (!isUserInteracting) {
      isUserInteracting = true;
      splide.Components.Autoplay.pause();
      console.log('PDP Design Slider: Auto-scroll paused (user interaction)');
    }
    
    // Clear existing timeout
    clearTimeout(interactionTimeout);
    
    // Resume auto-scroll after 8 seconds of no interaction
    interactionTimeout = setTimeout(() => {
      isUserInteracting = false;
      splide.Components.Autoplay.play();
      console.log('PDP Design Slider: Auto-scroll resumed');
    }, 8000);
  }

  // Event listeners for user interactions
  sliderElement.addEventListener('mouseenter', () => {
    splide.Components.Autoplay.pause();
  });

  sliderElement.addEventListener('mouseleave', () => {
    if (!isUserInteracting) {
      splide.Components.Autoplay.play();
    }
  });

  // Touch and click interactions
  sliderElement.addEventListener('touchstart', pauseAutoScroll);
  sliderElement.addEventListener('mousedown', pauseAutoScroll);
  
  // Arrow and pagination clicks
  const arrows = sliderElement.querySelectorAll('.splide__arrow');
  const pagination = sliderElement.querySelectorAll('.splide__pagination__page');
  
  arrows.forEach(arrow => {
    arrow.addEventListener('click', pauseAutoScroll);
  });
  
  pagination.forEach(dot => {
    dot.addEventListener('click', pauseAutoScroll);
  });

  // Keyboard navigation
  sliderElement.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === ' ') {
      pauseAutoScroll();
    }
  });

  // Add visual indicator for auto-scroll
  addAutoScrollIndicator(sliderElement, splide);
}

/**
 * Add visual progress indicator for auto-scroll
 */
function addAutoScrollIndicator(sliderElement, splide) {
  // Create progress bar
  const progressBar = document.createElement('div');
  progressBar.className = 'pdp-design-auto-scroll-progress';
  progressBar.innerHTML = '<div class="pdp-design-progress-fill"></div>';
  
  // Add CSS for progress bar
  const style = document.createElement('style');
  style.textContent = `
    .pdp-design-auto-scroll-progress {
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 2px;
      background: rgba(44, 44, 44, 0.2);
      border-radius: 1px;
      overflow: hidden;
      z-index: 10;
    }
    
    .pdp-design-progress-fill {
      height: 100%;
      background: #2c2c2c;
      width: 0%;
      border-radius: 1px;
      transition: width 0.1s linear;
    }
    
    .pdp-design-auto-scroll-progress.paused .pdp-design-progress-fill {
      animation-play-state: paused;
    }
    
    @media screen and (max-width: 768px) {
      .pdp-design-auto-scroll-progress {
        bottom: -15px;
        width: 50px;
      }
    }
  `;
  
  document.head.appendChild(style);
  sliderElement.appendChild(progressBar);
  
  const progressFill = progressBar.querySelector('.pdp-design-progress-fill');
  
  // Update progress bar
  let progressInterval;
  
  function startProgress() {
    let progress = 0;
    const interval = splide.options.interval || 4000;
    const step = 100 / (interval / 50); // Update every 50ms
    
    progressInterval = setInterval(() => {
      progress += step;
      if (progress >= 100) {
        progress = 0;
      }
      progressFill.style.width = progress + '%';
    }, 50);
  }
  
  function stopProgress() {
    clearInterval(progressInterval);
    progressFill.style.width = '0%';
  }
  
  // Listen to autoplay events
  splide.on('autoplay:playing', startProgress);
  splide.on('autoplay:pause', () => {
    clearInterval(progressInterval);
    progressBar.classList.add('paused');
  });
  
  splide.on('autoplay:play', () => {
    progressBar.classList.remove('paused');
    startProgress();
  });
  
  splide.on('moved', () => {
    progressFill.style.width = '0%';
  });
}

/**
 * Intersection Observer for performance optimization
 */
function initIntersectionObserver(splide) {
  if (!('IntersectionObserver' in window)) return;

  const sliderElement = document.querySelector('#pdp-design-image-splide');
  if (!sliderElement) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Slider is visible, ensure auto-scroll is active
        splide.Components.Autoplay.play();
        console.log('PDP Design Slider: In viewport - auto-scroll active');
      } else {
        // Slider is not visible, pause auto-scroll to save resources
        splide.Components.Autoplay.pause();
        console.log('PDP Design Slider: Out of viewport - auto-scroll paused');
      }
    });
  }, {
    threshold: 0.3, // Trigger when 30% of slider is visible
    rootMargin: '50px' // Start 50px before entering viewport
  });

  observer.observe(sliderElement);
}

/**
 * Add touch gesture support for mobile
 */
function initTouchGestures(splide) {
  const sliderElement = document.querySelector('#pdp-design-image-splide');
  if (!sliderElement) return;

  let touchStartX = 0;
  let touchEndX = 0;

  sliderElement.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  });

  sliderElement.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  });

  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe left - next slide
        splide.go('+1');
      } else {
        // Swipe right - previous slide
        splide.go('-1');
      }
    }
  }
}

// Initialize touch gestures after DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const splide = document.querySelector('#pdp-design-image-splide');
    if (splide && splide.splide) {
      initTouchGestures(splide.splide);
    }
  }, 100);
});
